import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChatMessageProps } from '../../onboarding/types';

interface MigrationState {
  data: Record<string, any>;
  currentStep: number;
  messages: ChatMessageProps[];
  currentQuestionIndex: number;
}

const initialState: MigrationState = {
  data: {},
  currentStep: 0,
  messages: [],
  currentQuestionIndex: 0,
};

export const migrationSlice = createSlice({
  name: 'migration',
  initialState,
  reducers: {
    updateMigrationData: (
      state,
      action: PayloadAction<Record<string, any>>
    ) => {
      state.data = { ...state.data, ...action.payload };
    },
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    setMessages: (state, action: PayloadAction<ChatMessageProps[]>) => {
      state.messages = action.payload;
    },
    setCurrentQuestionIndex: (state, action: PayloadAction<number>) => {
      state.currentQuestionIndex = action.payload;
    },
    resetMigration: (state) => {
      state.data = {};
      state.currentStep = 0;
      state.messages = [];
      state.currentQuestionIndex = 0;
    },
  },
});

export const {
  updateMigrationData,
  setCurrentStep,
  setMessages,
  setCurrentQuestionIndex,
  resetMigration,
} = migrationSlice.actions;

export default migrationSlice.reducer;
